import { useState } from "react";
import { api, LOGO_URL } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { toast } from "sonner";
import LangSwitcher from "../components/LangSwitcher";

export default function ComingSoon() {
  const { t, lang } = useI18n();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error(t("popup_email_required"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/subscribers", {
        email: email.trim(),
        phone: phone.trim(),
        lang,
      });
      setDone(true);
      toast.success(t("coming_thanks"));
    } catch {
      toast.error("Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="coming-soon"
      className="min-h-screen bg-black text-white flex flex-col"
    >
      {/* Top bar */}
      <header className="border-b border-zinc-900 px-6 md:px-10 h-20 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="ALLSTAR" className="h-10 w-10 object-contain" />
          <span className="font-display text-xl uppercase tracking-tighter">
            ALLSTAR
          </span>
        </div>
        <LangSwitcher />
      </header>

      {/* Subtle green halo */}
      <div className="relative flex-1 flex items-center justify-center overflow-hidden px-6">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-green-500/5 blur-[140px] pointer-events-none" />

        <div className="relative w-full max-w-2xl text-center fade-up">
          <img
            src={LOGO_URL}
            alt="ALLSTAR"
            className="h-24 w-24 md:h-32 md:w-32 object-contain mx-auto mb-10"
          />

          <div className="flex items-center justify-center gap-3 mb-6 text-xs uppercase tracking-[0.3em] text-zinc-400">
            <span className="w-10 h-px bg-green-400" />
            <span>{t("coming_kicker")}</span>
            <span className="w-10 h-px bg-green-400" />
          </div>

          <h1 className="font-display uppercase tracking-tighter leading-[0.9] text-[18vw] md:text-[10vw] mb-8">
            {t("coming_title")}
          </h1>

          <p className="text-zinc-400 text-base md:text-lg max-w-lg mx-auto mb-12 leading-relaxed">
            {t("coming_subtitle")}
          </p>

          {!done ? (
            <form
              onSubmit={submit}
              className="max-w-md mx-auto space-y-3"
              data-testid="coming-form"
            >
              <input
                data-testid="coming-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("popup_email")}
                className="w-full bg-black border border-zinc-800 focus:border-green-500 outline-none px-4 py-4 text-white placeholder-zinc-600 text-center transition-colors"
              />
              <input
                data-testid="coming-phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder={t("popup_phone")}
                className="w-full bg-black border border-zinc-800 focus:border-green-500 outline-none px-4 py-4 text-white placeholder-zinc-600 text-center transition-colors"
              />
              <button
                type="submit"
                data-testid="coming-submit"
                disabled={loading}
                className="w-full bg-green-500 hover:bg-green-400 text-black font-bold uppercase tracking-widest py-4 transition-colors disabled:opacity-60"
              >
                {loading ? "…" : t("coming_notify")}
              </button>
            </form>
          ) : (
            <div className="max-w-md mx-auto border border-green-500/40 bg-green-500/5 p-8 text-green-400 font-display uppercase tracking-tight text-xl">
              {t("coming_thanks")}
            </div>
          )}
        </div>
      </div>

      <footer className="border-t border-zinc-900 px-6 md:px-10 py-6 text-center text-[10px] uppercase tracking-[0.3em] text-zinc-600">
        © {new Date().getFullYear()} ALLSTAR — {t("coming_locked")}
      </footer>
    </div>
  );
}
